import { BaseFactory } from 'src/services/entity-factory/FactoryInterface';
import AptitudeTestChoice from 'src/entities/AptitudeTestChoice';

export interface ApiAptitudeTestChoiceResponse {
  id: number;
  text: string;
}

interface ApiAptitudeTestChoiceCreateRequest {

}

export class AptitudeTestChoiceFactory extends BaseFactory<AptitudeTestChoice> {
  public toEntity(args: ApiAptitudeTestChoiceResponse): AptitudeTestChoice {
    return new AptitudeTestChoice({
      id: args.id,
      text: args.text,
    });
  }

  public toRequest(aptitudeTestChoice: AptitudeTestChoice): ApiAptitudeTestChoiceCreateRequest {
    return aptitudeTestChoice;
  }
}


// WEBPACK FOOTER //
// ./src/services/entity-factory/factories/AptitudeTestChoiceFactory.tsx